(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireee5d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireee5d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $bc44b5da379ac29b$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("4ko55"), JSON.parse('["4ko55","index.fe11498a.js","hOerA","icons.c14567a0.svg"]'));

function $d30aa9e28595ada5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $d30aa9e28595ada5$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $d30aa9e28595ada5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $d30aa9e28595ada5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $47e0aa82139bfe16$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $3433e5a3eb89c040$var$extendStatics = function extendStatics1(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function __assign1() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $47e0aa82139bfe16$export$5f0017c582d45a2d)(x)) === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $47e0aa82139bfe16$export$5f0017c582d45a2d)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};



function $a568c0d5880c90ba$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $1928e6784807450d$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $e70cad04b84cd1c0$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $db996d728bd6bdbf$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $21be0414e7551937$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c35227b66bb73462$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $7a656066cb9fb4bf$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c35227b66bb73462$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c35227b66bb73462$export$79e617b1955a2616)(o, minLen);
}


function $b6c37a1b08cb752d$export$fdf2a89c76341bbf(arr, i) {
    return (0, $e70cad04b84cd1c0$export$e6256bf45c68d561)(arr) || (0, $db996d728bd6bdbf$export$2fd15edff6687200)(arr, i) || (0, $7a656066cb9fb4bf$export$a5be06335b3a083c)(arr, i) || (0, $21be0414e7551937$export$60dbc22abd7da546)();
}



var $a536fbf06af412b5$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes/";
var $a536fbf06af412b5$export$196440f71ed9f601 = 2;
var $a536fbf06af412b5$export$5feaddb1377b7f5e = 10;
var $a536fbf06af412b5$export$7167c830cefcb6b5 = "6f171b1b-7a45-4d91-a428-b1185abfda29"; // export const KEY = 'baaa8526-5076-41d6-a1bd-4c440b649037';





var $77eae7726dbdfc03$var$timeout = function timeout(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error("Request took too long! Timeout after ".concat(s, " second")));
        }, s * 1000);
    });
};
var $77eae7726dbdfc03$export$e68fce4c5f453854 = function() {
    var _ref = (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function(url, recipe) {
        var fetchPro, response, data, err;
        return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    fetchPro = recipe ? fetch(url, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(recipe)
                    }) : fetch(url);
                    return [
                        4,
                        Promise.race([
                            fetchPro,
                            $77eae7726dbdfc03$var$timeout((0, $a536fbf06af412b5$export$196440f71ed9f601))
                        ])
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    if (!response.ok) throw Error("".concat(data.message, " (").concat(response.status, ")"));
                    return [
                        2,
                        data
                    ];
                case 3:
                    err = _state.sent();
                    throw new Error(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function ajax(url, recipe) {
        return _ref.apply(this, arguments);
    };
}();


var $0bc36518f6cf0450$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        page: 1,
        resultsPerPage: (0, $a536fbf06af412b5$export$5feaddb1377b7f5e)
    },
    bookmarks: [],
    isSearchOpen: false,
    isSearchWindowOpen: false
};
var $0bc36518f6cf0450$var$getRecipeObject = function(data) {
    var recipe = data.data.recipe;
    return (0, $1928e6784807450d$export$581ff339ea0ba762)({
        cookingTime: recipe.cooking_time,
        id: recipe.id,
        imageUrl: recipe.image_url,
        ingredients: recipe.ingredients,
        publisher: recipe.publisher,
        servings: recipe.servings,
        sourceUrl: recipe.source_url,
        title: recipe.title
    }, recipe.key && {
        key: recipe.key
    });
};
var $0bc36518f6cf0450$export$b96725c7a035d60b = function() {
    var _ref = (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function(id) {
        var data, err;
        return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $77eae7726dbdfc03$export$e68fce4c5f453854)("".concat((0, $a536fbf06af412b5$export$923ea8233b386e99)).concat(id, "?key=").concat((0, $a536fbf06af412b5$export$7167c830cefcb6b5)))
                    ];
                case 1:
                    data = _state.sent();
                    $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe = $0bc36518f6cf0450$var$getRecipeObject(data);
                    $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.some(function(recipe) {
                        return recipe.id === $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id;
                    }) ? true : false;
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    throw new Error(err);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadRecipe(id) {
        return _ref.apply(this, arguments);
    };
}();
var $0bc36518f6cf0450$export$202b8e5cb363a0c4 = function() {
    var _ref = (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function(query) {
        var data, err;
        return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    $0bc36518f6cf0450$export$ca000e230c0caa3e.search.query = query;
                    return [
                        4,
                        (0, $77eae7726dbdfc03$export$e68fce4c5f453854)("".concat((0, $a536fbf06af412b5$export$923ea8233b386e99), "?search=").concat(query, "&key=").concat((0, $a536fbf06af412b5$export$7167c830cefcb6b5)))
                    ];
                case 1:
                    data = _state.sent();
                    $0bc36518f6cf0450$export$ca000e230c0caa3e.search.results = data.data.recipes.map(function(recipe) {
                        return (0, $1928e6784807450d$export$581ff339ea0ba762)({
                            id: recipe.id,
                            imageUrl: recipe.image_url,
                            publisher: recipe.publisher,
                            title: recipe.title
                        }, recipe.key && {
                            key: recipe.key
                        });
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadSearchResults(query) {
        return _ref.apply(this, arguments);
    };
}();
var $0bc36518f6cf0450$export$c6b70b628aa585b0 = function() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $0bc36518f6cf0450$export$ca000e230c0caa3e.search.page;
    $0bc36518f6cf0450$export$ca000e230c0caa3e.search.page = page;
    var start = (page - 1) * (0, $a536fbf06af412b5$export$5feaddb1377b7f5e);
    var end = page * (0, $a536fbf06af412b5$export$5feaddb1377b7f5e);
    return $0bc36518f6cf0450$export$ca000e230c0caa3e.search.results.slice(start, end);
};
var $0bc36518f6cf0450$export$5e23f4642ecad5ea = function(serving) {
    $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.ingredients.forEach(function(ing) {
        ing.quantity = ing.quantity * serving / $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.servings;
    });
    $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.servings = serving;
};
var $0bc36518f6cf0450$export$72009cc673d27d80 = function(recipe) {
    $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.push(recipe);
    if (recipe.id === $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id) $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $0bc36518f6cf0450$export$c54ab59e0c864b2f();
};
var $0bc36518f6cf0450$export$2db69b245b3902c8 = function(id) {
    var index = $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.findIndex(function(bookmark) {
        return bookmark.id === id;
    });
    $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    if (id === $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id) $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $0bc36518f6cf0450$export$c54ab59e0c864b2f();
};
var $0bc36518f6cf0450$export$c54ab59e0c864b2f = function() {
    localStorage.setItem("bookmarks", JSON.stringify($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks));
};
var $0bc36518f6cf0450$export$7c7816efe5f3d2b8 = function() {
    var _localStorage_getItem;
    $0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks = JSON.parse((_localStorage_getItem = localStorage.getItem("bookmarks")) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : "[]");
};
var $0bc36518f6cf0450$export$d660c2254e74960d = function() {
    var _ref = (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function(newRecipe) {
        var ingredients, recipe, data, err;
        return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    ingredients = Object.entries(newRecipe).filter(function(entry) {
                        return entry[0].startsWith("ingredient") && entry[1].trim().length > 0;
                    }).map(function(entry) {
                        var ingArr = entry[1].split(",").map(function(ing) {
                            return ing.trim();
                        });
                        if (ingArr.length !== 3) throw new Error("Wrong Format Input");
                        var _ingArr = (0, $b6c37a1b08cb752d$export$fdf2a89c76341bbf)(ingArr, 3), quantity = _ingArr[0], unit = _ingArr[1], description = _ingArr[2];
                        return {
                            quantity: quantity ? +quantity : null,
                            unit: unit,
                            description: description
                        };
                    });
                    recipe = {
                        cooking_time: +newRecipe.cookingTime,
                        image_url: newRecipe.image,
                        ingredients: ingredients,
                        publisher: newRecipe.publisher,
                        servings: +newRecipe.servings,
                        source_url: newRecipe.sourceUrl,
                        title: newRecipe.title
                    };
                    return [
                        4,
                        (0, $77eae7726dbdfc03$export$e68fce4c5f453854)("".concat((0, $a536fbf06af412b5$export$923ea8233b386e99), "?key=").concat((0, $a536fbf06af412b5$export$7167c830cefcb6b5)), recipe)
                    ];
                case 1:
                    data = _state.sent();
                    $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe = $0bc36518f6cf0450$var$getRecipeObject(data);
                    $0bc36518f6cf0450$export$72009cc673d27d80($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function uploadRecipe(newRecipe) {
        return _ref.apply(this, arguments);
    };
}();


function $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $e3055412a69a0bec$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $89767be5ae191d10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $89767be5ae191d10$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $89767be5ae191d10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $89767be5ae191d10$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



function $29ba11907b394831$export$c2c98ac76e997b63(o, p) {
    $29ba11907b394831$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $29ba11907b394831$export$c2c98ac76e997b63(o, p);
}


function $e23c82ff3e4e415d$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $29ba11907b394831$export$c2c98ac76e997b63)(subClass, superClass);
}


function $40cae3b32ee7ab1c$export$f09211a7d3c496a1(o) {
    $40cae3b32ee7ab1c$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $40cae3b32ee7ab1c$export$f09211a7d3c496a1(o);
}


function $68d2f7aa73fd860f$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}




function $3feb72aea5525294$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $47e0aa82139bfe16$export$5f0017c582d45a2d)(call) === "object" || typeof call === "function")) return call;
    return (0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(self);
}


function $3a5851a3803a7a32$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $68d2f7aa73fd860f$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $40cae3b32ee7ab1c$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $40cae3b32ee7ab1c$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $3feb72aea5525294$export$ef97c660ca164e52)(this, result);
    };
}


var $a922e5462747601b$exports = {};

$a922e5462747601b$exports = (parcelRequire("aNJCr")).getBundleURL("4ko55") + "icons.c14567a0.svg";






var $c732e9e6223e19d8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function View() {
        (0, $e3055412a69a0bec$export$2996f80ef42b8419)(this, View);
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)(this, "_data", void 0);
    }
    (0, $89767be5ae191d10$export$d60067ff2358eee8)(View, [
        {
            key: "render",
            value: function render(data) {
                var render = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
                this._data = data;
                var markup = this._generateMarkup();
                if (!render) return markup;
                this._clear();
                this._parentElement.insertAdjacentHTML("afterbegin", markup);
            }
        },
        {
            key: "_clear",
            value: function _clear() {
                this._parentElement.innerHTML = "";
            }
        },
        {
            key: "update",
            value: function update(data) {
                this._data = data;
                var newMarkup = this._generateMarkup();
                var newDom = document.createRange().createContextualFragment(newMarkup);
                var newDomElements = Array.from(newDom.querySelectorAll("*"));
                var curDomElements = Array.from(this._parentElement.querySelectorAll("*"));
                newDomElements.forEach(function(newDomEl, i) {
                    var _newDomEl_firstChild;
                    if (!newDomEl.isEqualNode(curDomElements[i]) && (newDomEl === null || newDomEl === void 0 ? void 0 : (_newDomEl_firstChild = newDomEl.firstChild) === null || _newDomEl_firstChild === void 0 ? void 0 : _newDomEl_firstChild.nodeValue.trim()) !== "") curDomElements[i].textContent = newDomEl.textContent;
                    if (!newDomEl.isEqualNode(curDomElements[i])) Array.from(newDomEl.attributes).forEach(function(attr) {
                        curDomElements[i].setAttribute(attr.name, attr.value);
                    });
                });
            }
        },
        {
            key: "renderSpinner",
            value: function renderSpinner() {
                this._clear();
                var markup = '\n      <div class="spinner">\n        <svg>\n          <use href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-loader"></use>\n        </svg>\n      </div>\n    ');
                this._parentElement.insertAdjacentHTML("afterbegin", markup);
            }
        },
        {
            key: "renderError",
            value: function renderError() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._errorMessage;
                var markup = '\n      <div class="error">\n      <div>\n      <svg>\n      <use href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-alert-triangle"></use>\n      </svg>\n      </div>\n      <p>').concat(message, "</p>\n      </div>\n      ");
                this._clear();
                this._parentElement.insertAdjacentHTML("afterbegin", markup);
            }
        },
        {
            key: "renderMessage",
            value: function renderMessage() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._message;
                var markup = '\n        <div class="message">\n        <div>\n        <svg>\n        <use href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-smile"></use>\n        </svg>\n        </div>\n        <p>').concat(message, "</p>\n        </div>\n        ");
                this._clear();
                this._parentElement.insertAdjacentHTML("afterbegin", markup);
            }
        }
    ]);
    return View;
}();


var $95a7d6c4a0a50ae1$var$RecipeView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $e23c82ff3e4e415d$export$7e4530ad35d3bb8)(RecipeView, View);
    var _super = (0, $3a5851a3803a7a32$export$8dd05c13f5255580)(RecipeView);
    function RecipeView() {
        (0, $e3055412a69a0bec$export$2996f80ef42b8419)(this, RecipeView);
        var _this;
        _this = _super.apply(this, arguments);
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_parentElement", document.querySelector(".recipe"));
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_errorMessage", "No recipes found for your query. Please try again!");
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_message", "");
        return _this;
    }
    (0, $89767be5ae191d10$export$d60067ff2358eee8)(RecipeView, [
        {
            key: "addHandlerRender",
            value: function addHandlerRender(handler) {
                [
                    "hashchange",
                    "load"
                ].forEach(function(ev) {
                    window.addEventListener(ev, handler);
                });
            }
        },
        {
            key: "addHandlerUpdateServings",
            value: function addHandlerUpdateServings(handler) {
                this._parentElement.addEventListener("click", function(e) {
                    var button = e.target.closest(".btn--tiny");
                    var serving = +(button === null || button === void 0 ? void 0 : button.dataset.serving);
                    if (!button || serving <= 0 || serving > 100) return;
                    handler(serving);
                });
            }
        },
        {
            key: "addHandlerBookmark",
            value: function addHandlerBookmark(handler) {
                this._parentElement.addEventListener("click", function(e) {
                    var button = e.target.closest(".btn--bookmark");
                    if (!button) return;
                    handler();
                });
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return '\n        <figure class="recipe__fig">\n        <img src="'.concat(this._data.imageUrl, '" class="recipe__img" crossorigin/>\n        <h1 class="recipe__title">\n        <span>').concat(this._data.title, '</span>\n        </h1>\n        </figure>\n        \n        <div class="recipe__details">\n        <div class="recipe__info-group">\n\n        <div class="recipe__info">\n        <svg class="recipe__info-icon">\n        <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-clock"></use>\n        </svg>\n        <span class="recipe__info-data recipe__info-data--minutes">').concat(this._data.cookingTime, '</span>\n        <span class="recipe__info-text">minutes</span>\n        </div>\n        <div class="recipe__info">\n        <svg class="recipe__info-icon">\n        <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-users"></use>\n        </svg>\n        <span class="recipe__info-data recipe__info-data--people">').concat(this._data.servings, '</span>\n        <span class="recipe__info-text">servings</span>\n        \n        <div class="recipe__info-buttons">\n        <button data-serving=').concat(this._data.servings - 1, ' class="btn--tiny btn--increase-servings">\n        <svg>\n        <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-minus-circle"></use>\n        </svg>\n        </button>\n        <button data-serving=').concat(this._data.servings + 1, ' class="btn--tiny btn--increase-servings">\n        <svg>\n        <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-plus-circle"></use>\n        </svg>\n        </button>\n        </div>\n        </div>\n        </div>\n\n        <div class="recipe__user-generated ').concat(this._data.key ? "" : "hidden", '">\n            <svg>\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-user"></use>\n            </svg>\n        </div>\n        <button class="btn--round btn--bookmark">\n        <svg class="">\n        <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), "#icon-bookmark").concat(this._data.bookmarked ? "-fill" : "", '"></use>\n        </svg>\n        </button>\n        </div>\n        \n        <div class="recipe__ingredients">\n        <h2 class="heading--2">Recipe ingredients</h2>\n        <ul class="recipe__ingredient-list">\n        ').concat(this._data.ingredients.map(this._generateIngredients).join("\n"), '\n        </ul>\n        </div>\n        \n        <div class="recipe__directions">\n        <h2 class="heading--2">How to cook it</h2>\n        <p class="recipe__directions-text">\n        This recipe was carefully designed and tested by\n        <span class="recipe__publisher">').concat(this._data.publisher, '</span>. Please check out\n        directions at their website.\n        </p>\n        <a\n        class="btn--small recipe__btn"\n        href="').concat(this._data.sourceUrl, '"\n        target="_blank"\n        >\n        <span>Directions</span>\n        <svg class="search__icon">\n        <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-arrow-right"></use>\n        </svg>\n        </a>\n        </div>\n        ');
            }
        },
        {
            key: "_generateIngredients",
            value: function _generateIngredients(ing) {
                var _ing_quantity, _ing_unit;
                return '\n        <li class="recipe__ingredient">\n        <svg class="recipe__icon">\n        <use href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-check"></use>\n        </svg>\n        <div class="recipe__quantity">').concat((_ing_quantity = ing.quantity) !== null && _ing_quantity !== void 0 ? _ing_quantity : "", '</div>\n        <div class="recipe__description">\n        <span class="recipe__unit">').concat((_ing_unit = ing.unit) !== null && _ing_unit !== void 0 ? _ing_unit : "", "</span>\n        ").concat(ing.description, "\n        </div>\n        </li>\n        ");
            }
        }
    ]);
    return RecipeView;
}((0, $c732e9e6223e19d8$export$2e2bcd8739ae039));
var $95a7d6c4a0a50ae1$export$2e2bcd8739ae039 = new $95a7d6c4a0a50ae1$var$RecipeView();



function $9ff32953017c5856$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $bf616bc1ae020d65$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $190bb0c0b1d52a41$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $bf616bc1ae020d65$export$20c20a422940e173)(receiver, privateMap, "get");
    return (0, $9ff32953017c5856$export$184ff5d81c0e5775)(receiver, descriptor);
}


function $3f4cfa4c4c8b2a05$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $4d635caf5261a471$export$e235798705076415(obj, privateMap, value) {
    (0, $3f4cfa4c4c8b2a05$export$6b10452b5ac97eba)(obj, privateMap);
    privateMap.set(obj, value);
}


function $5b0d287cb614f7d5$export$ccedaf978f62b9dd(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}



function $143d29618c0708d5$export$1002c20f28174dbf(obj, privateSet) {
    (0, $3f4cfa4c4c8b2a05$export$6b10452b5ac97eba)(obj, privateSet);
    privateSet.add(obj);
}




var $8d9571d82bdb9304$var$_parentElement = /*#__PURE__*/ new WeakMap(), $8d9571d82bdb9304$var$_searchButton = /*#__PURE__*/ new WeakMap(), $8d9571d82bdb9304$var$_searchWindow = /*#__PURE__*/ new WeakMap(), $8d9571d82bdb9304$var$_searchWindowButton = /*#__PURE__*/ new WeakMap(), $8d9571d82bdb9304$var$_clear = /*#__PURE__*/ new WeakSet();
var $8d9571d82bdb9304$var$SearchView = /*#__PURE__*/ function() {
    "use strict";
    function SearchView() {
        (0, $e3055412a69a0bec$export$2996f80ef42b8419)(this, SearchView);
        (0, $143d29618c0708d5$export$1002c20f28174dbf)(this, $8d9571d82bdb9304$var$_clear);
        (0, $4d635caf5261a471$export$e235798705076415)(this, $8d9571d82bdb9304$var$_parentElement, {
            writable: true,
            value: document.querySelector(".search")
        });
        (0, $4d635caf5261a471$export$e235798705076415)(this, $8d9571d82bdb9304$var$_searchButton, {
            writable: true,
            value: document.querySelector(".nav .search__btn")
        });
        (0, $4d635caf5261a471$export$e235798705076415)(this, $8d9571d82bdb9304$var$_searchWindow, {
            writable: true,
            value: document.querySelector(".search-results")
        });
        (0, $4d635caf5261a471$export$e235798705076415)(this, $8d9571d82bdb9304$var$_searchWindowButton, {
            writable: true,
            value: document.querySelector(".search-results .search-window__btn")
        });
        // super();
        this._addHandlerWindow();
    }
    (0, $89767be5ae191d10$export$d60067ff2358eee8)(SearchView, [
        {
            key: "_addHandlerWindow",
            value: function _addHandlerWindow() {
                var _this = this;
                (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_searchWindowButton).addEventListener("click", function(e) {
                    _this.toggleWindow();
                });
            }
        },
        {
            key: "getQuery",
            value: function getQuery() {
                var query = (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_parentElement).querySelector(".search__field").value;
                (0, $5b0d287cb614f7d5$export$ccedaf978f62b9dd)(this, $8d9571d82bdb9304$var$_clear, $8d9571d82bdb9304$var$clear).call(this);
                return query;
            }
        },
        {
            key: "addSearchHandler",
            value: function addSearchHandler(handler) {
                var _this = this;
                (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_parentElement).addEventListener("submit", function(e) {
                    e.preventDefault();
                    handler((0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(_this, $8d9571d82bdb9304$var$_parentElement));
                    _this.toggleWindow(true);
                });
            }
        },
        {
            key: "addSearchButtonHandler",
            value: function addSearchButtonHandler(handler) {
                var _this = this;
                (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_searchButton).addEventListener("click", function(e) {
                    e.preventDefault();
                    handler((0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(_this, $8d9571d82bdb9304$var$_parentElement), (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(_this, $8d9571d82bdb9304$var$_searchButton));
                });
            }
        },
        {
            key: "addSearchWindowHandler",
            value: function addSearchWindowHandler(handler) {
                var _this = this;
                (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_searchWindowButton).addEventListener("click", function(e) {
                    e.preventDefault();
                    handler((0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(_this, $8d9571d82bdb9304$var$_searchWindow), (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(_this, $8d9571d82bdb9304$var$_searchWindowButton));
                });
            }
        },
        {
            key: "toggleWindow",
            value: function toggleWindow() {
                var toOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                if ((0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_searchWindowButton).classList.contains("search-window__btn-hide") && (0, $0bc36518f6cf0450$export$ca000e230c0caa3e).search.query) (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_searchWindowButton).classList.remove("search-window__btn-hide");
                if (toOpen == null) {
                    if ((0, $0bc36518f6cf0450$export$ca000e230c0caa3e).search.query) (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_searchWindow).classList.toggle("search-results-open");
                    document.body.classList.toggle("body--no-scroll");
                } else if (toOpen) {
                    (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_searchWindow).classList.add("search-results-open");
                    document.body.classList.add("body--no-scroll");
                } else {
                    (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_searchWindow).classList.remove("search-results-open");
                    document.body.classList.remove("body--no-scroll");
                }
            }
        }
    ]);
    return SearchView;
}();
function $8d9571d82bdb9304$var$clear() {
    (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_parentElement).querySelector(".search__field").value = "";
    (0, $190bb0c0b1d52a41$export$5a67b255b80ee4f2)(this, $8d9571d82bdb9304$var$_parentElement).querySelector(".search__field").blur();
}
var $8d9571d82bdb9304$export$2e2bcd8739ae039 = new $8d9571d82bdb9304$var$SearchView();

















var $d511a9d636491df2$var$resultView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $e23c82ff3e4e415d$export$7e4530ad35d3bb8)(resultView, View);
    var _super = (0, $3a5851a3803a7a32$export$8dd05c13f5255580)(resultView);
    function resultView() {
        (0, $e3055412a69a0bec$export$2996f80ef42b8419)(this, resultView);
        var _this;
        _this = _super.apply(this, arguments);
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_parentElement", "");
        return _this;
    }
    (0, $89767be5ae191d10$export$d60067ff2358eee8)(resultView, [
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var id = window.location.hash.slice(1);
                return '\n      <li class="preview">\n        <a class="preview__link '.concat(id === this._data.id ? "preview__link--active" : "", '" href="#').concat(this._data.id, '">\n            <figure class="preview__fig">\n            <img src="').concat(this._data.imageUrl, '" alt="').concat(this._data.title, '" crossorigin/>\n            </figure>\n            <div class="preview__this._data">\n            <h4 class="preview__title">').concat(this._data.title, '</h4>\n            <p class="preview__publisher">').concat(this._data.publisher, '</p>\n            <div class="preview__user-generated ').concat(this._data.key ? "" : "hidden", '">\n                <svg>\n                <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-user"></use>\n                </svg>\n            </div>\n            </div>\n        </a>\n      </li>\n      ');
            }
        }
    ]);
    return resultView;
}((0, $c732e9e6223e19d8$export$2e2bcd8739ae039));
var $d511a9d636491df2$export$2e2bcd8739ae039 = new $d511a9d636491df2$var$resultView();



var $825378b838d49178$var$resultView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $e23c82ff3e4e415d$export$7e4530ad35d3bb8)(resultView, View);
    var _super = (0, $3a5851a3803a7a32$export$8dd05c13f5255580)(resultView);
    function resultView() {
        (0, $e3055412a69a0bec$export$2996f80ef42b8419)(this, resultView);
        var _this;
        _this = _super.apply(this, arguments);
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_parentElement", document.querySelector(".results"));
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_errorMessage", "No recipes found for your query. Please try again!");
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_message", "");
        return _this;
    }
    (0, $89767be5ae191d10$export$d60067ff2358eee8)(resultView, [
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return this._data.map(function(recipe) {
                    return (0, $d511a9d636491df2$export$2e2bcd8739ae039).render(recipe, false);
                }).join("\n");
            }
        }
    ]);
    return resultView;
}((0, $c732e9e6223e19d8$export$2e2bcd8739ae039));
var $825378b838d49178$export$2e2bcd8739ae039 = new $825378b838d49178$var$resultView();











var $f03ebf78cca01ded$var$paginationView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $e23c82ff3e4e415d$export$7e4530ad35d3bb8)(paginationView, View);
    var _super = (0, $3a5851a3803a7a32$export$8dd05c13f5255580)(paginationView);
    function paginationView() {
        (0, $e3055412a69a0bec$export$2996f80ef42b8419)(this, paginationView);
        var _this;
        _this = _super.apply(this, arguments);
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_parentElement", document.querySelector(".pagination"));
        return _this;
    }
    (0, $89767be5ae191d10$export$d60067ff2358eee8)(paginationView, [
        {
            key: "addPaginationHandler",
            value: function addPaginationHandler(handler) {
                this._parentElement.addEventListener("click", function(e) {
                    var button = e.target.closest(".btn--inline");
                    if (!button) return;
                    var goto = +button.dataset.goto;
                    handler(goto);
                });
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var curPage = this._data.page;
                var numPages = Math.ceil(this._data.results.length / (0, $a536fbf06af412b5$export$5feaddb1377b7f5e));
                var prevButton = "\n      <button data-goto=".concat(curPage - 1, ' class="btn--inline pagination__btn--prev">\n        <svg class="search__icon">\n          <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-arrow-left"></use>\n        </svg>\n        <span>Page ').concat(curPage - 1, "</span>\n      </button>\n      ");
                var nextButton = "\n        <button data-goto=".concat(curPage + 1, ' class="btn--inline pagination__btn--next">\n          <span>Page ').concat(curPage + 1, '</span>\n          <svg class="search__icon">\n            <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-arrow-right"></use>\n          </svg>\n        </button>\n      ');
                if (curPage === 1) prevButton = "";
                if (curPage === numPages) nextButton = "";
                return "".concat(prevButton).concat(nextButton);
            }
        }
    ]);
    return paginationView;
}((0, $c732e9e6223e19d8$export$2e2bcd8739ae039));
var $f03ebf78cca01ded$export$2e2bcd8739ae039 = new $f03ebf78cca01ded$var$paginationView();











var $0884acaefafcc64c$var$BookmarksView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $e23c82ff3e4e415d$export$7e4530ad35d3bb8)(BookmarksView, View);
    var _super = (0, $3a5851a3803a7a32$export$8dd05c13f5255580)(BookmarksView);
    function BookmarksView() {
        (0, $e3055412a69a0bec$export$2996f80ef42b8419)(this, BookmarksView);
        var _this;
        _this = _super.apply(this, arguments);
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_parentElement", document.querySelector(".bookmarks__list"));
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_errorMessage", "No bookmarks yet. Find a nice recipe and bookmark it :)");
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_message", "");
        return _this;
    }
    (0, $89767be5ae191d10$export$d60067ff2358eee8)(BookmarksView, [
        {
            key: "addHandlerRender",
            value: function addHandlerRender(handler) {
                window.addEventListener("load", handler);
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return this._data.map(function(bookmark) {
                    return (0, $d511a9d636491df2$export$2e2bcd8739ae039).render(bookmark, false);
                }).join("\n");
            }
        }
    ]);
    return BookmarksView;
}((0, $c732e9e6223e19d8$export$2e2bcd8739ae039));
var $0884acaefafcc64c$export$2e2bcd8739ae039 = new $0884acaefafcc64c$var$BookmarksView();








function $64ef3ecb073cf3d1$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c35227b66bb73462$export$79e617b1955a2616)(arr);
}


function $e7a1e1249a38f823$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $5063040d55f66da2$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $7fed984c591c61d1$export$1b5e630bc3aea29f(arr) {
    return (0, $64ef3ecb073cf3d1$export$7e0947b5ad3404e2)(arr) || (0, $e7a1e1249a38f823$export$1eb58a6e75231000)(arr) || (0, $7a656066cb9fb4bf$export$a5be06335b3a083c)(arr) || (0, $5063040d55f66da2$export$e6f3c4780d19eb2b)();
}






var $da53bbe9f60c4332$var$addRecipeView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $e23c82ff3e4e415d$export$7e4530ad35d3bb8)(addRecipeView, View);
    var _super = (0, $3a5851a3803a7a32$export$8dd05c13f5255580)(addRecipeView);
    function addRecipeView() {
        (0, $e3055412a69a0bec$export$2996f80ef42b8419)(this, addRecipeView);
        var _this;
        _this = _super.call(this);
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_parentElement", document.querySelector(".upload"));
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_message", "Recipe Uploaded Successfully!");
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_overlay", document.querySelector(".overlay"));
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_window", document.querySelector(".add-recipe-window"));
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_closeBtn", document.querySelector(".btn--close-modal"));
        (0, $a568c0d5880c90ba$export$1e71eb4bef00f6b0)((0, $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8)(_this), "_openBtn", document.querySelector(".nav__btn--add-recipe"));
        _this._addHandlerOpen();
        _this._addHandlerClose();
        return _this;
    }
    (0, $89767be5ae191d10$export$d60067ff2358eee8)(addRecipeView, [
        {
            key: "toggleWindow",
            value: function toggleWindow() {
                this._overlay.classList.toggle("hidden");
                this._window.classList.toggle("hidden");
                this._clear();
                var markup = this._generateMarkup();
                this._parentElement.insertAdjacentHTML("afterbegin", markup);
            }
        },
        {
            key: "_addHandlerOpen",
            value: function _addHandlerOpen() {
                this._openBtn.addEventListener("click", this.toggleWindow.bind(this));
            }
        },
        {
            key: "_addHandlerClose",
            value: function _addHandlerClose() {
                this._closeBtn.addEventListener("click", this.toggleWindow.bind(this));
                this._overlay.addEventListener("click", this.toggleWindow.bind(this));
            }
        },
        {
            key: "addHandlerSubmit",
            value: function addHandlerSubmit(handler) {
                this._parentElement.addEventListener("submit", function(e) {
                    e.preventDefault();
                    var dataArr = (0, $7fed984c591c61d1$export$1b5e630bc3aea29f)(new FormData(this));
                    var data = Object.fromEntries(dataArr);
                    handler(data);
                });
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return '\n      <div class="upload__column">\n      <h3 class="upload__heading">Recipe data</h3>\n      <label>Title</label>\n      <input required name="title" type="text" />\n      <label>URL</label>\n      <input required name="sourceUrl" type="text" />\n      <label>Image URL</label>\n      <input required name="image" type="text" />\n      <label>Publisher</label>\n      <input required name="publisher" type="text" />\n      <label>Prep time</label>\n      <input required name="cookingTime" type="number" />\n      <label>Servings</label>\n      <input required name="servings" type="number" />\n    </div>\n\n    <div class="upload__column">\n      <h3 class="upload__heading">Ingredients</h3>\n      <label>Ingredient 1</label>\n      <input\n        type="text"\n        required\n        name="ingredient-1"\n        placeholder="Format: \'Quantity,Unit,Description\'"\n      />\n      <label>Ingredient 2</label>\n      <input\n        type="text"\n        name="ingredient-2"\n        placeholder="Format: \'Quantity,Unit,Description\'"\n      />\n      <label>Ingredient 3</label>\n      <input\n        type="text"\n        name="ingredient-3"\n        placeholder="Format: \'Quantity,Unit,Description\'"\n      />\n      <label>Ingredient 4</label>\n      <input\n        type="text"\n        name="ingredient-4"\n        placeholder="Format: \'Quantity,Unit,Description\'"\n      />\n      <label>Ingredient 5</label>\n      <input\n        type="text"\n        name="ingredient-5"\n        placeholder="Format: \'Quantity,Unit,Description\'"\n      />\n      <label>Ingredient 6</label>\n      <input\n        type="text"\n        name="ingredient-6"\n        placeholder="Format: \'Quantity,Unit,Description\'"\n      />\n    </div>\n\n    <button class="btn upload__btn">\n      <svg>\n        <use href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))), '#icon-upload-cloud"></use>\n        \n      </svg>\n      <span>Upload</span>\n    </button>\n      ');
            }
        }
    ]);
    return addRecipeView;
}((0, $c732e9e6223e19d8$export$2e2bcd8739ae039));
var $da53bbe9f60c4332$export$2e2bcd8739ae039 = new $da53bbe9f60c4332$var$addRecipeView();


// import 'core-js/stable';
// import { async } from 'regenerator-runtime/runtime';
// https://forkify-api.herokuapp.com/v2
///////////////////////////////////////
// if (module.hot) {
//   module.hot.accept();
// }
var $cdc8bba1cf7e6fe0$var$getRecipe = function() {
    var _ref = (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function() {
        var id, err;
        return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    id = window.location.hash.slice(1);
                    if (!id) return [
                        2
                    ];
                    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).renderSpinner();
                    (0, $825378b838d49178$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$c6b70b628aa585b0());
                    (0, $0884acaefafcc64c$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
                    (0, $8d9571d82bdb9304$export$2e2bcd8739ae039).toggleWindow(false);
                    return [
                        4,
                        $0bc36518f6cf0450$export$b96725c7a035d60b(id)
                    ];
                case 1:
                    _state.sent();
                    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).renderError(err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getRecipe() {
        return _ref.apply(this, arguments);
    };
}();
var $cdc8bba1cf7e6fe0$var$controlSearchResults = function() {
    var _ref = (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function(parent) {
        var query, err;
        return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    (0, $825378b838d49178$export$2e2bcd8739ae039).renderSpinner();
                    query = (0, $8d9571d82bdb9304$export$2e2bcd8739ae039).getQuery();
                    if (!query) return [
                        2
                    ];
                    return [
                        4,
                        $0bc36518f6cf0450$export$202b8e5cb363a0c4(query)
                    ];
                case 1:
                    _state.sent();
                    parent.classList.remove("search-open");
                    $0bc36518f6cf0450$export$ca000e230c0caa3e.isSearchOpen = false;
                    (0, $825378b838d49178$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$c6b70b628aa585b0(1));
                    (0, $f03ebf78cca01ded$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.search);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function controlSearchResults(parent) {
        return _ref.apply(this, arguments);
    };
}();
var $cdc8bba1cf7e6fe0$var$controlPagination = function(goto) {
    (0, $825378b838d49178$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$c6b70b628aa585b0(goto));
    (0, $f03ebf78cca01ded$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.search);
};
var $cdc8bba1cf7e6fe0$var$controlServings = function(serving) {
    $0bc36518f6cf0450$export$5e23f4642ecad5ea(serving);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
};
var $cdc8bba1cf7e6fe0$var$controlBookmark = function() {
    if (!$0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.bookmarked) $0bc36518f6cf0450$export$72009cc673d27d80($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    else $0bc36518f6cf0450$export$2db69b245b3902c8($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).update($0bc36518f6cf0450$export$ca000e230c0caa3e.recipe);
    (0, $0884acaefafcc64c$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
};
var $cdc8bba1cf7e6fe0$var$controlLoadBookmarks = function() {
    $0bc36518f6cf0450$export$7c7816efe5f3d2b8();
    (0, $0884acaefafcc64c$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
};
var $cdc8bba1cf7e6fe0$var$controlAddRecipe = function() {
    var _ref = (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function(recipe) {
        var err;
        return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).renderSpinner();
                    return [
                        4,
                        $0bc36518f6cf0450$export$d660c2254e74960d(recipe)
                    ];
                case 1:
                    _state.sent();
                    (0, $0884acaefafcc64c$export$2e2bcd8739ae039).render($0bc36518f6cf0450$export$ca000e230c0caa3e.bookmarks);
                    (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).renderMessage();
                    window.location.hash = $0bc36518f6cf0450$export$ca000e230c0caa3e.recipe.id;
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).renderError(err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function controlAddRecipe(recipe) {
        return _ref.apply(this, arguments);
    };
}();
var $cdc8bba1cf7e6fe0$var$controlSearch = function(parent, button) {
    if (!$0bc36518f6cf0450$export$ca000e230c0caa3e.isSearchOpen) {
        var actionEvent;
        $0bc36518f6cf0450$export$ca000e230c0caa3e.isSearchOpen = true;
        document.removeEventListener("click", actionEvent);
        parent.classList.add("search-open");
        console.log($0bc36518f6cf0450$export$ca000e230c0caa3e.isSearchOpen);
        actionEvent = function(e) {
            if (!e.target.closest(".search") && !e.target.closest(".nav .search__btn")) {
                $0bc36518f6cf0450$export$ca000e230c0caa3e.isSearchOpen = false;
                console.log($0bc36518f6cf0450$export$ca000e230c0caa3e.isSearchOpen);
                parent.classList.remove("search-open");
                document.removeEventListener("click", actionEvent);
            }
        };
        document.addEventListener("click", actionEvent);
    }
};
var $cdc8bba1cf7e6fe0$var$init = function() {
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).addHandlerRender($cdc8bba1cf7e6fe0$var$getRecipe);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).addHandlerUpdateServings($cdc8bba1cf7e6fe0$var$controlServings);
    (0, $95a7d6c4a0a50ae1$export$2e2bcd8739ae039).addHandlerBookmark($cdc8bba1cf7e6fe0$var$controlBookmark);
    (0, $0884acaefafcc64c$export$2e2bcd8739ae039).addHandlerRender($cdc8bba1cf7e6fe0$var$controlLoadBookmarks);
    (0, $8d9571d82bdb9304$export$2e2bcd8739ae039).addSearchHandler($cdc8bba1cf7e6fe0$var$controlSearchResults);
    (0, $8d9571d82bdb9304$export$2e2bcd8739ae039).addSearchButtonHandler($cdc8bba1cf7e6fe0$var$controlSearch);
    (0, $f03ebf78cca01ded$export$2e2bcd8739ae039).addPaginationHandler($cdc8bba1cf7e6fe0$var$controlPagination);
    (0, $da53bbe9f60c4332$export$2e2bcd8739ae039).addHandlerSubmit($cdc8bba1cf7e6fe0$var$controlAddRecipe);
    console.log("Welcome to Forkify!");
};
$cdc8bba1cf7e6fe0$var$init();

})();
//# sourceMappingURL=index.fe11498a.js.map
